var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrap"},[_c('el-pagination',{attrs:{"hide-on-single-page":_vm.value,"current-page":_vm.currentPage,"page-sizes":[5, 10, 20, 30],"page-size":+_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }